







































































































































import { Vue, Component } from 'vue-property-decorator';
import NavBar from '@/components/common/NavBar.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import { Chart, registerables, ChartData } from 'chart.js';
import { ChartModule } from '@/store/modules/chart';
import 'datatables.net-dt';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import $ from 'jquery';

interface Table {
  value: string;
  text: string;
}

Chart.register(...registerables);

@Component({
  components: {
    NavBar,
    SelectionField
  }
})
export default class Dashboard extends Vue {
  lineChartInstance: any = null;
  phaseBarChartInstance: any = null;
  technologyPieChartInstance: any = null;
  systemPieChartInstance: any = null;

  selectedPhaseBarChartData = 'all';
  selectedTechnologyPieChartData = 'all';
  selectedSystemPieChartData = 'all';

  tables = [
    { value: "MUNICIPALITY", text: "団体別プロセス数" },
    { value: "SEEN_BY", text: "閲覧数トップ10のプロセス" }
  ]

  table: Table = this.tables[0];

  backgroundColors = [
    '#EE8A3C',
    '#3D5386',
    '#D9A577',
    '#5A7D9A',
    '#EAD2AC',
    '#729FAF',
    '#F4C95D',
    '#9BC1BC',
    '#ED6A5A',
    '#606C38'
  ];

  get phaseChartDTO() {
    return ChartModule.phaseChartDTO;
  }

  get technologyChartDTO() {
    return ChartModule.technologyChartDTO;
  }

  get systemChartDTO() {
    return ChartModule.systemChartDTO;
  }

  get municipalityChartDTO() {
    return ChartModule.municipalityChartDTO;
  }

  get seenByChartDTO() {
    return ChartModule.seenByChartDTO;
  }

  get historyChartDTO() {
    return ChartModule.historyChartDTO;
  }

  get phaseBarChartDataOwn() {
    const labels = this.phaseChartDTO?.ownLabels || [];
    const data = this.phaseChartDTO?.ownData || [];

    return {
      labels,
      datasets: [
        {
          label: 'フェーズ別プロセス数',
          data,
          backgroundColor: '#ee8a3c',
          borderColor: '#ee8a3c',
          borderWidth: 1
        }
      ]
    } as ChartData<'bar'>;
  }

  get phaseBarChartDataAll() {
    const labels = this.phaseChartDTO?.totalLabels || [];
    const data = this.phaseChartDTO?.totalData || [];

    return {
      labels,
      datasets: [
        {
          label: 'フェーズ別プロセス数',
          data,
          backgroundColor: '#3d5386',
          borderColor: '#3d5386',
          borderWidth: 1
        }
      ]
    } as ChartData<'bar'>;
  }

  get technologyPieChartDataOwn() {
    const labels = this.technologyChartDTO?.ownLabels || [];
    const data = this.technologyChartDTO?.ownData || [];

    return {
      labels,
      datasets: [
        {
          label: '使用技術',
          data,
          backgroundColor: this.backgroundColors,
          borderWidth: 1
        }
      ]
    };
  }

  get technologyPieChartDataAll() {
    const labels = this.technologyChartDTO?.totalLabels || [];
    const data = this.technologyChartDTO?.totalData || [];

    return {
      labels,
      datasets: [
        {
          label: '使用技術',
          data,
          backgroundColor: this.backgroundColors,
          borderWidth: 1
        }
      ]
    };
  }

  get systemPieChartDataOwn() {
    const labels = this.systemChartDTO?.ownLabels || [];
    const data = this.systemChartDTO?.ownData || [];

    return {
      labels,
      datasets: [
        {
          label: '使用ITシステム',
          data,
          backgroundColor: this.backgroundColors,
          borderWidth: 1
        }
      ]
    };
  }

  get systemPieChartDataAll() {
    const labels = this.systemChartDTO?.totalLabels || [];
    const data = this.systemChartDTO?.totalData || [];

    return {
      labels,
      datasets: [
        {
          label: '使用ITシステム',
          data,
          backgroundColor: this.backgroundColors,
          borderWidth: 1
        }
      ]
    };
  }

  get lineChartData() {
    const labels = this.historyChartDTO?.totalLabels || [];
    const dataTotal = this.historyChartDTO?.totalData || [];
    const dataOwn = this.historyChartDTO?.ownData || [];

    return {
      labels,
      datasets: [
        {
          label: '合計',
          data: dataTotal,
          fill: false,
          borderColor: '#3d5386',
          backgroundColor: '#3d5386'
        },
        {
          label: '自団体',
          data: dataOwn,
          fill: false,
          borderColor: '#ee8a3c',
          backgroundColor: '#ee8a3c'
        }
      ]
    };
  }

  async mounted() {
    this.loadPhaseChartDTO();
    this.loadTechnologyChartDTO();
    this.loadMunicipalityChartDTO();
    this.loadHistoryChartDTO();
    this.loadSystemChartDTO();
    this.loadSeenByChartDTO();

    window.addEventListener('resize', this.handleResize);
  }

  async handleResize() {
    location.reload();
  }

  async loadPhaseChartDTO() {
    await ChartModule.loadPhaseChartDTO();
    this.renderPhaseBarChart();
  }

  async loadTechnologyChartDTO() {
    await ChartModule.loadTechnologyChartDTO();
    this.renderTechnologyPieChart();
  }

  async loadMunicipalityChartDTO() {
    await ChartModule.loadMunicipalityChartDTO();
    this.renderDataTable();
  }

  async loadSeenByChartDTO() {
    await ChartModule.loadSeenByChartDTO();
    this.renderSeenByDatatable();
  }

  async loadHistoryChartDTO() {
    await ChartModule.loadHistoryChartDTO();
    this.renderLineChart();
  }

  async loadSystemChartDTO() {
    await ChartModule.loadSystemChartDTO();
    this.renderSystemPieChart();
  }

  renderDataTable() {
    const dataTable = $('#municipalityDatatable').DataTable({
      destroy: true,
      paging: false,
      order: [[1, 'desc']],
      language: {
        search: '検索',
        lengthMenu: '',
        info: '_TOTAL_ 件中 _START_～_END_ 件を表示',
        zeroRecords: 'データがありません',
        infoEmpty: '',
        infoFiltered: '（全 _MAX_ 件から絞り込み）'
      }
    });
  }

  renderSeenByDatatable() {
    const seenByDataTable = $('#seenByDatatable').DataTable({
      destroy: true,
      paging: false,
      order: [[0, 'asc']],
      language: {
        search: '検索',
        lengthMenu: '',
        info: '_TOTAL_ 件中 _START_～_END_ 件を表示',
        zeroRecords: 'データがありません',
        infoEmpty: '',
        infoFiltered: '（全 _MAX_ 件から絞り込み）'
      }
    });
  }

  renderLineChart() {
    // wait for canvas to be rendered
    this.$nextTick(() => {
      const canvas = this.$refs.lineChartCanvas as HTMLCanvasElement | null;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          this.lineChartInstance = new Chart(ctx, {
            type: 'line',
            data: this.lineChartData,
            options: {
              scales: {
                y: {
                  beginAtZero: true
                }
              },
              plugins: {
                title: {
                  display: true,
                  text: 'プロセス数の推移',
                  font: {
                    size: 16
                  }
                }
              }
            }
          });
        }
      }
    });
  }

  renderPhaseBarChart() {
    // wait for canvas to be rendered
    this.$nextTick(() => {
      const canvas = this.$refs.phaseBarChartCanvas as HTMLCanvasElement | null;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          this.phaseBarChartInstance = new Chart(ctx, {
            type: 'bar',
            data: this.phaseBarChartDataAll,
            options: {
              scales: {
                y: {
                  beginAtZero: true
                }
              },
              plugins: {
                title: {
                  display: true,
                  text: 'フェーズ別プロセス数',
                  font: {
                    size: 16
                  }
                }
              }
            }
          });
        }
      }
    });
  }

  renderTechnologyPieChart() {
    // wait for canvas to be rendered
    this.$nextTick(() => {
      const canvas = this.$refs.technologyPieChartCanvas as HTMLCanvasElement | null;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          this.technologyPieChartInstance = new Chart(ctx, {
            type: 'pie',
            data: this.technologyPieChartDataAll,
            options: {
              plugins: {
                title: {
                  display: true,
                  text: '使用技術トップ10',
                  font: {
                    size: 16
                  }
                }
              }
            }
          });
        }
      }
    });
  }

  renderSystemPieChart() {
    // wait for canvas to be rendered
    this.$nextTick(() => {
      const canvas = this.$refs.systemPieChartCanvas as HTMLCanvasElement | null;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          this.systemPieChartInstance = new Chart(ctx, {
            type: 'pie',
            data: this.systemPieChartDataAll,
            options: {
              plugins: {
                title: {
                  display: true,
                  text: '使用システムトップ10',
                  font: {
                    size: 16
                  }
                }
              }
            }
          });
        }
      }
    });
  }

  handlePhaseBarChartRadioButtonChange() {
    if (this.selectedPhaseBarChartData === 'all') {
      this.phaseBarChartInstance.data = this.phaseBarChartDataAll;
    } else if (this.selectedPhaseBarChartData === 'own') {
      this.phaseBarChartInstance.data = this.phaseBarChartDataOwn;
    }
    this.phaseBarChartInstance.update();
  }

  handleTechnologyPieChartRadioButtonChange() {
    if (this.selectedTechnologyPieChartData === 'all') {
      this.technologyPieChartInstance.data = this.technologyPieChartDataAll;
    } else if (this.selectedTechnologyPieChartData === 'own') {
      this.technologyPieChartInstance.data = this.technologyPieChartDataOwn;
    }
    this.technologyPieChartInstance.update();
  }

  handleSystemPieChartRadioButtonChange() {
    if (this.selectedSystemPieChartData === 'all') {
      this.systemPieChartInstance.data = this.systemPieChartDataAll;
    } else if (this.selectedSystemPieChartData === 'own') {
      this.systemPieChartInstance.data = this.systemPieChartDataOwn;
    }
    this.systemPieChartInstance.update();
  }

  updateTable(selectedTable: Table) {
    this.table = selectedTable;
  }

  async clearFilters() {
    location.reload();
  }
}
